module.exports = __webpack_public_path__ + "425d0b7b2ee328faea09eef5cebd31f2.png";